import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ListContainer } from 'components';
import DistributorDetails from './distributor-details/DistributorDetails';
import DistributorInvite from './DistributorInvite';
import DistributorsTable from './DistributorsTable';

const Distributors = () => {
    return (
        <ListContainer>
            <Routes>
                <Route path="details/:id" element={<DistributorDetails />} />
                <Route path="create" element={<DistributorInvite />} />
                <Route path="edit/:id" element={<DistributorInvite />} />
                <Route index element={<DistributorsTable />} />
                <Route path="*" element={<Navigate to="/distributors" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default Distributors;
